import { ACCOUNT_FIELD_MAX_LENGTH, VALIDATION_PATTERNS } from '@app/domain/uiConsts';
import { convertToTranslatedMessage } from '@app/utils/form/formTranslatedMessage';
import { trim } from '@app/utils/stringUtils';
import { onChangeValidateOtherFields, requireOnOtherFieldFull } from '@app/utils/validators';
import { SupplierRegistrationField } from '@supplierRegistration/domain/supplierRegistrationAccountDetailsFields';
import {
  BaseFormFields,
  SupplierRegistrationCountryFields,
} from '@supplierRegistration/domain/supplierRegistrationCountryFields';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { ReactNode } from 'react';
import { ConditionalValidationRule } from '@app/utils/form/form';
import { CURRENCIES_KEYS } from '@app/domain/currencies';
function getBankCodeFields(form: WrappedFormUtils<BaseFormFields>): SupplierRegistrationField {
  return {
    id: 'inpt-supp-reg-CN-bank-code',
    inputType: 'text',
    decoratorRules: [
      {
        max: ACCOUNT_FIELD_MAX_LENGTH.default.bank,
        transform: trim,
        translatedMessage: {
          key: 'supplierValidation.supplierRegister.maxCharacters',
          value: ACCOUNT_FIELD_MAX_LENGTH.default.bank,
        },
      },
      {
        pattern: VALIDATION_PATTERNS.alphanumericWithChineseAndDashes,
        transform: trim,
        translatedMessage: [
          `supplierValidation.supplierRegister.CN.errors.invalidBankCode`,
          'supplierValidation.supplierRegister.errors.invalidBankCode',
        ],
      },
      {
        transform: trim,
        validator: requireOnOtherFieldFull(
          form,
          'branchCode',
          convertToTranslatedMessage([
            `supplierValidation.supplierRegister.CN.errors.missingBankCode`,
            'supplierValidation.supplierRegister.errors.missingBankCode',
          ]) as ReactNode,
        ),
      },
      {
        validator: onChangeValidateOtherFields<BaseFormFields>(form, 'branchCode'),
      },
    ],
  };
}

function getBranchCodeFields(form: WrappedFormUtils<BaseFormFields>): SupplierRegistrationField {
  return {
    id: 'inpt-supp-reg-CN-branch-code',
    inputType: 'text',
    decoratorRules: [
      {
        max: ACCOUNT_FIELD_MAX_LENGTH.default.branch,
        transform: trim,
        translatedMessage: {
          key: 'supplierValidation.supplierRegister.maxCharacters',
          value: ACCOUNT_FIELD_MAX_LENGTH.default.branch,
        },
      },
      {
        pattern: VALIDATION_PATTERNS.alphanumericWithChineseAndDashes,
        transform: trim,
        translatedMessage: [
          `supplierValidation.supplierRegister.CN.errors.invalidBranchCode`,
          'supplierValidation.supplierRegister.errors.invalidBranchCode',
        ],
      },
      {
        transform: trim,
        validator: requireOnOtherFieldFull(
          form,
          'bankCode',
          convertToTranslatedMessage([
            `supplierValidation.supplierRegister.CN.errors.missingBranchCode`,
            'supplierValidation.supplierRegister.errors.missingBranchCode',
          ]) as ReactNode,
        ),
      },
      {
        validator: onChangeValidateOtherFields<BaseFormFields>(form, 'bankCode'),
      },
    ],
  };
}

export enum ChinaLegalIdTypesForCompany {
  CompanyID = 'Company ID',
  BRNChina = 'Business Registration Number',
  Other = 'Other',
}

function getAdditionalSwiftRules(form: WrappedFormUtils<BaseFormFields>): ConditionalValidationRule[] {
  return [
    {
      required: form.getFieldValue('currency') === CURRENCIES_KEYS.USD,
      transform: trim,
      translatedMessage: 'supplierValidation.supplierRegister.errors.missingSwift',
    },
  ];
}

export const CN: SupplierRegistrationCountryFields = {
  bankCode: getBankCodeFields,
  branchCode: getBranchCodeFields,
  leis: { types: ChinaLegalIdTypesForCompany },
  additionalCompanyName: true,
  swiftCodeAdditionalRules: getAdditionalSwiftRules,
};
